import { render, staticRenderFns } from "./FulfillmentInfo.vue?vue&type=template&id=a9ae2404&scoped=true"
import script from "./FulfillmentInfo.vue?vue&type=script&lang=ts"
export * from "./FulfillmentInfo.vue?vue&type=script&lang=ts"
import style0 from "./FulfillmentInfo.vue?vue&type=style&index=0&id=a9ae2404&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ae2404",
  null
  
)

export default component.exports